/**
 * Merge a newly confirmed placement intent into the ones already collected in
 * this deferred dialog session.
 *
 * The same pin gets reported more than once: the auto-confirm effect fires on
 * every direction change, and Save reports it again. Collecting by appending
 * meant one placement per report, so a single photo ended up pinned twice on
 * the floorplan with two "placement saved" snackbars. The newest intent instead
 * supersedes any earlier one covering the same image on the same floorplan —
 * last position and direction win, one placement per image.
 */
export function mergePlacementIntent(collected, intent) {
  const superseded = new Set(intent.filePermissionIds);
  const remaining = collected
    .map((existing) => {
      if (existing.floorplanId !== intent.floorplanId) return existing;
      return {
        ...existing,
        filePermissionIds: existing.filePermissionIds.filter(
          (id) => !superseded.has(id)
        ),
      };
    })
    .filter((existing) => existing.filePermissionIds.length > 0);
  return [...remaining, intent];
}
